import { gql } from '@apollo/client'

export const themeFragments = gql`
	fragment ThemeData on Theme {
		id
		primary_color
		accent_color
		color_mode
		logo_url
		wordmark_url
		favicon_url
		hero_image_url
	}
`

export const conventionSeriesFragments = gql`
	fragment ConventionSeriesData on ConventionSeries {
		id
		name
		slug
		stripe_connected
		stripe_connected_account_id
		social_media {
			tiktok_url
			facebook_url
			twitter_url
			instagram_url
			youtube_url
			twitch_url
			discord_url
			terms_of_service_url
			privacy_policy_url
		}
	}
`

export const conventionFragments = gql`
	fragment ConventionData on Convention {
		id
		name
		start_date
		end_date
		venue
		building
		address_components
		address_formatted
		convention_series_id
		convention_series {
			...ConventionSeriesData
		}
		effective_theme {
			...ThemeData
		}
	}
`

export const GET_CONVENTION = gql`
	query getConvention($id: ID!) {
		convention(id: $id) {
			...ConventionData
		}
	}
	${conventionFragments}
	${conventionSeriesFragments}
	${themeFragments}
`

export const GET_CONVENTION_SERIES = gql`
	query getConventionSeries {
		convention_series {
			...ConventionSeriesData
		}
	}
	${conventionSeriesFragments}
`

export const GET_CONVENTIONS = gql`
	query getConventions($series_id: ID, $series_slug: String) {
		conventions(series_id: $series_id, series_slug: $series_slug) {
			...ConventionData
		}
	}
	${conventionFragments}
	${conventionSeriesFragments}
	${themeFragments}
`

export const GET_CURRENT_CONVENTION = gql`
	query getCurrentConvention {
		current_convention {
			...ConventionData
		}
	}
	${conventionFragments}
	${conventionSeriesFragments}
	${themeFragments}
`
